/**
 * Skeleton coerente col `HeroBillsChart` reale: card navy con barre bianche.
 */

export function HeroBillsChartSkeleton() {
  return (
    <div className="relative flex h-full animate-pulse flex-col overflow-hidden rounded-xl bg-primary p-6 dark:bg-[#0F1E3D]">
      <div className="space-y-2">
        <div className="h-3 w-32 rounded bg-white/15" />
        <div className="h-5 w-56 rounded bg-white/20" />
      </div>

      <div className="mt-5 h-3 w-72 max-w-full rounded bg-white/10" />

      <div className="mt-3 flex h-[88px] items-end gap-1.5">
        {Array.from({ length: 10 }).map((_, i) => (
          <div key={i} className="h-full flex-1 rounded-sm bg-white/10">
            <div
              className="h-full w-full rounded-sm bg-white/25"
              style={{
                height: `${30 + (i * 53) % 60}%`,
                marginTop: 'auto',
              }}
            />
          </div>
        ))}
      </div>

      <div className="mt-5 flex justify-around border-t border-white/15 pt-4">
        <div className="space-y-1.5 text-center">
          <div className="mx-auto h-3 w-12 rounded bg-white/15" />
          <div className="mx-auto h-4 w-16 rounded bg-white/25" />
        </div>
        <div className="space-y-1.5 text-center">
          <div className="mx-auto h-3 w-20 rounded bg-white/15" />
          <div className="mx-auto h-4 w-14 rounded bg-white/25" />
        </div>
      </div>
    </div>
  )
}
